module.exports = __webpack_public_path__ + "static/media/IMG-10.a70797e3.jpg";